import React from 'react';
import { hanThanhToanSearchColumns, QUERY_KEYS } from '@/constants';
import { FormFieldActions, FormFieldState } from '../../../hooks';
import { FormField, SearchField } from '@/components/custom/erp';
import { HanThanhToan } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface PaymentInfoTabProps {
  formMode: FormMode;
  formState: {
    state: FormFieldState;
    actions: FormFieldActions;
  };
}

export const PaymentInfoTab: React.FC<PaymentInfoTabProps> = ({ formMode, formState: { state, actions } }) => {
  const disabled = formMode === 'view';

  return (
    <div className='flex flex-col gap-2 p-4'>
      <div className='grid grid-cols-[100px,1fr] items-start gap-y-1 sm:grid-cols-[120px,1fr] sm:items-center'>
        <Label className='text-sm font-medium'>Theo dõi thanh toán</Label>
        <FormField name='hd_yn' type='checkbox' disabled={disabled} />
      </div>

      <div className='grid grid-cols-[100px,1fr] items-start gap-y-1 sm:grid-cols-[120px,1fr] sm:items-center'>
        <Label className='text-sm font-medium'>Số chứng từ</Label>
        <div className='w-[200px]'>
          <FormField name='so_ct0' type='text' disabled={disabled} />
        </div>
      </div>

      <div className='grid grid-cols-[100px,1fr] items-start gap-y-1 sm:grid-cols-[120px,1fr] sm:items-center'>
        <Label className='text-sm font-medium'>Ngày chứng từ</Label>
        <div className='w-[200px]'>
          <FormField name='ngay_ct0' type='date' disabled={disabled} />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-[7.5rem] text-sm font-medium'>Mã thanh toán</Label>
        <SearchField<HanThanhToan>
          type='text'
          disabled={disabled}
          dialogTitle='Danh mục hạn thanh toán'
          searchEndpoint={`/${QUERY_KEYS.HAN_THANH_TOAN}`}
          searchColumns={hanThanhToanSearchColumns}
          displayRelatedField='ten_tt'
          columnDisplay='ma_tt'
          value={state.hanThanhToan?.ma_tt || ''}
          relatedFieldValue={state.hanThanhToan?.ten_tt || ''}
          onRowSelection={actions.setHanThanhToan}
        />
      </div>
    </div>
  );
};
